import { render, staticRenderFns } from "./AttachClientPayment.vue?vue&type=template&id=026178f9&"
import script from "./AttachClientPayment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AttachClientPayment.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports